import React, { useEffect, useState, useContext } from 'react'
import { connect } from 'react-redux'
import { array, bool, shape } from 'prop-types'

import { postComment, getComments } from 'src/actions/prioritize'
// import { Select } from 'src/components/shared'
import { AddComment, Comment } from './components'
import { CommentsContext, sortBy, defaultContext } from './components/util';
import '../Prioritize.module.scss'
import './Comments.scss'

const Comments = ({
  postComment,
  getComments,
  comments: commentsProp,
  isShowComments,
  isNewCommentOpen,
  setDisplayOption: setOption,
  collectionId,
  readOnly,
}) => {
  const [sortKey] = useState('created')
  const [comments, setComments] = useState([])
  const [contextValue, setContextValue] = useState(defaultContext)

  const sortAndUpdateComments = () => {
    if (!!commentsProp && !!collectionId)
      setComments(sortBy(commentsProp[collectionId] || [], sortKey))
  }

  useEffect(() => {
    sortAndUpdateComments();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setContextValue({ postComment, collectionId, comments, sortKey, readOnly });
    // eslint-disable-next-line
  }, [collectionId, comments, sortKey, readOnly])

  useEffect(() => {
    sortAndUpdateComments();
    // eslint-disable-next-line
  }, [commentsProp, sortKey])

  useEffect(() => {
    if (!!collectionId) getComments(collectionId);
    // eslint-disable-next-line
  }, [collectionId])

  if (!comments || !isShowComments) return null

  return (
    <div className={`comments-container ${readOnly ? 'readonly' : ''}`}>
      {/* <div className="comments-filters">
        <Select
          value={dropdownOptions.find((o) => o.value === sortKey).value}
          itemList={dropdownOptions}
          onSelected={(item) => setSortKey(item.value)}
          border={false}
        />
      </div> */}
      <CommentsContext.Provider value={contextValue}>
        {isNewCommentOpen && (
          <AddComment parentId={null} closeText={() => setOption('open')} />
        )}
        <CommentComposite parentId={null} />
      </CommentsContext.Provider>
    </div>
  )
}

/**
 * Composite component
 * @param level current level
 * @param parentId null for root, otherwise: id of a comment which is being replied to
 * @param comments list of all the comments for this parent and this level children
 * @param isTextOpenOnThisLevel is parent comment is being replied to
 * @returns
 * - New comment textfield before all replies (comments) on same level
 * - List of comments on this level
 * - And itself to allow multilevel reply
 */
const CommentComposite = ({ level = 0, parentId }) => {
  const context = useContext(CommentsContext)
  const { comments: allComments } = context
  const comments = allComments.filter((c) => c.parent_id === parentId)

  if (level >= 3) return null

  return (
    <div className="comments-indent">
      <div className="comments-list">
        {comments.map((comment, index) => (
          <React.Fragment key={index}>
            <Comment key={index} level={level + 1} comment={comment} />
            <CommentComposite level={level + 1} parentId={comment.id} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

Comments.propTypes = {
  collection: shape({
    children: array,
  }),
  readOnly: bool,
  isShowComments: bool,
}

Comments.defaultProps = {
  collection: {
    children: [],
  },
  readOnly: false,
  isShowComments: true,
}

const mapStateToProps = (state) => {
  return {
    collection: state.prioritize.collection,
    comments: state.prioritize.comments,
    user: state.user.user,
  }
}

export default connect(mapStateToProps, {
  postComment,
  getComments,
})(Comments)
